import { RecaptchaVerifier, signInWithPhoneNumber, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { auth } from './firebase'

let persistenceDone = false
let recaptchaVerifier = null

async function ensurePersistence() {
  if (typeof window === 'undefined' || persistenceDone) return
  persistenceDone = true
  try {
    await setPersistence(auth, browserLocalPersistence)
  } catch {
    // non-fatal
  }
}

/**
 * Web SMS OTP via Firebase Phone Auth. Requires Phone provider + reCAPTCHA in Firebase Console.
 * Authorized domains must include your hosting domain (e.g. totalrewardspro.com, localhost).
 */
export function clearPhoneRecaptcha() {
  try {
    recaptchaVerifier?.clear?.()
  } catch {
    // ignore
  }
  recaptchaVerifier = null
}

function getOrCreateVerifier(containerId) {
  if (typeof window === 'undefined') return null
  clearPhoneRecaptcha()
  recaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
    size: 'invisible',
    callback: () => {}
  })
  return recaptchaVerifier
}

/**
 * @param {string} phoneNumber E.164, e.g. +919876543210
 * @param {string} containerId DOM element id for invisible reCAPTCHA (must exist in document)
 * @returns {Promise<import('firebase/auth').ConfirmationResult>}
 */
export async function sendCertificationOtp(phoneNumber, containerId = 'trp-phone-recaptcha') {
  await ensurePersistence()
  const el = document.getElementById(containerId)
  if (!el) {
    throw new Error('MISSING_RECAPTCHA_CONTAINER')
  }
  const verifier = getOrCreateVerifier(containerId)
  return signInWithPhoneNumber(auth, phoneNumber, verifier)
}
